export default __webpack_public_path__ + "80542a394a854eadfc4e3cceb241f04f.png";